module.exports = __webpack_public_path__ + "img/online-instruction.c99b2a2c.jpg";